import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import * as React from 'react';

export function SvgXCircle() {
  return <CrossCircleIcon label="" testId="ads-refreshed-icon" />;
}
